module.exports = __webpack_public_path__ + "static/media/tamara-scherzinger.ea050a48.jpg";